import React, { useEffect, useRef, useState } from 'react'
import { Box, Button, Card, CardHeader, Container, Dialog, DialogContent, DialogTitle, Divider, Grid, IconButton, MenuItem, Switch, TextField, Tooltip, Typography, styled } from '@mui/material'
import { Formik } from 'formik'
import * as Yup from "yup";
import CloseIcon from '@mui/icons-material/Close';
import CancelIcon from '@mui/icons-material/Cancel';
import axios from 'axios';
import { toast } from 'react-toastify';
import logo from '../Assests/Autopartslogo.png';


export default function ItemDialog({ dialogOpen, setDialogOpen, updateID, setUpdateID,isUpdateFromItem }) {
    const inputRef = useRef(null);
    const [itemData, setItemData] = useState({
        itemName: "",
        itemCategoryID: 0,
        itemType: 0,
        itemRemark: "",
        status: true,
        isChefPrep: false,
        sellingPrice: 0.0,
        costPrice: 0.0,
        defBarcode: "",
        isFavourite: false
    })
    const [categoryList, setCategoryList] = useState([]);
    const [img, setImg] = useState(null);
    const [previewImg, setPreviewImg] = useState(null);
    const [isImageUpload, setIsImageUpload] = useState(false);

    useEffect(() => {
        GetAllActiveCategoryDetails();
    }, [])

  
    function handleClose() {
        setDialogOpen(false);
        ClearData();
    }

    function handleChange(e) {
        const target = e.target;
        const value = target.value;
        setItemData({
            ...itemData,
            [e.target.name]: value
        })
    }

    function GetAllActiveCategoryDetails() {
        axios.get('https://serverrion.mylksystems.store/Category/getallactivecategory').then((res) => {
            if (res.data.length > 0) {
                setCategoryList(res.data);
            }
        })
    }

    function GetItemDetailByItemID() {
        axios.get(`https://serverrion.mylksystems.store/Item/getItemDetailByItemID/${updateID}`).then((res) => {
            //console.log("res.data:> ", res.data)
            if (res.data.length > 0) {
                setItemData({
                    ...itemData,
                    itemName: res.data[0].ItemName,
                    itemCategoryID: res.data[0].ItemCategoryID,
                    itemType: res.data[0].ItemTypeID,
                    itemRemark: res.data[0].ItemRemark,
                    status: res.data[0].IsActive == 1 ? true : false,
                    sellingPrice: res.data[0].sellingPrice,
                    costPrice: res.data[0].costPrice,
                    defBarcode: res.data[0].defbarcode ?? "",
                    isFavourite: res.data[0].isfavourite == 1 ? true : false,
                })
                setPreviewImg(res.data[0].ItemImage);
            }
        })
    }

    function ClearData() {
        setItemData({
            ...itemData,
            itemName: "",
            itemCategoryID: 0,
            itemType: 0,
            itemRemark: "",
            defBarcode: "",
            sellingPrice: 0.0,
            costPrice: 0.0,
            isFavourite: false,
            isChefPrep: false,
            status: true
        })
        removeImage();
        setIsImageUpload();
    }

    const uploadImage = (e) => {
        setImg(e.target.files[0]);
        setPreviewImg(URL.createObjectURL(e.target.files[0]));
        setIsImageUpload(true);
    }

    function removeImage() {
        setImg(null);
        setPreviewImg(null);
        if (inputRef.current) {
            inputRef.current.value = null; // Reset the input value
        }
    }

    function handleStatusChange() {
        setItemData({
            ...itemData,
            status: !itemData.status
        })
    }

    function handleFavouriteChange() {
        setItemData({
            ...itemData,
            isFavourite: !itemData.isFavourite
        })
    }

    function handleChefPrepChange() {
        setItemData({
            ...itemData,
            isChefPrep: !itemData.isChefPrep
        })
    }

    function UploadItem() {
 
            const formData = new FormData();
            formData.append("itemName", itemData.itemName.trim())
            formData.append("itemCategoryID", itemData.itemCategoryID)
            formData.append("itemRemark", itemData.itemRemark.trim())
            formData.append("status", itemData.status ? 1 : 0)
            formData.append("sellingPrice", itemData.sellingPrice)
            formData.append("costPrice", itemData.costPrice)
            formData.append("isFavourite", itemData.isFavourite ? 1 : 0)
            formData.append("isChefPrep", itemData.isChefPrep ? 1 : 0)
            formData.append("defBarcode", itemData.defBarcode ? itemData.defBarcode.trim() : "")
            formData.append("previewImg", previewImg)
            formData.append("file", previewImg ? img : null)

            //console.log(formData)
            axios.post('https://serverrion.mylksystems.store/Item/createItem', formData).then((res) => {
                if (res.data > 0) {
                    handleClose();
                    toast.success("Item Added successfully!");
                }
            })
        
    }

    return (
        <Dialog
            aria-labelledby="customized-dialog-title"
            open={dialogOpen}
            fullWidth={true}         // Ensures the dialog uses the full width of the container
            maxWidth='md'
        >
            <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                 Add Item
            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <CloseIcon sx={{ color: 'black' }} />
            </IconButton>
            <DialogContent dividers>
                <Container maxWidth={false}>
                    <Formik
                        initialValues={{
                            itemName: itemData.itemName,
                            itemCategoryID: itemData.itemCategoryID,
                            itemType: itemData.itemType,
                            itemRemark: itemData.itemRemark,
                            sellingPrice: itemData.sellingPrice,
                            costPrice: itemData.costPrice,
                            defBarcode: itemData.defBarcode,
                        }}

                        validationSchema={
                            Yup.object().shape({
                                itemName: Yup.string()
                                    .required('Item Name is required')
                                    .test('no-leading-space', 'Item Name cannot start with a space', value => value && value.trim().length > 0),
                                itemCategoryID: Yup.number()
                                    .required('Item Category is required')
                                    .test('valid-selection', 'Please select a valid item category', value => value !== 0),
                                defBarcode: Yup.string()
                                    .max(100, 'Default Barcode can be at most 100 characters.')
                            })
                        }

                        onSubmit={() => UploadItem()}
                        enableReinitialize
                    >
                        {({
                            errors,
                            handleBlur,
                            handleSubmit,
                            touched
                        }) => (
                            <form onSubmit={handleSubmit}>
                                <Box mt={0}>
                                    <Grid container spacing={2}>
                                        <Grid item md={6} xs={12}>
                                            <Grid container spacing={3}>
                                                <Grid item md={12} xs={12}>
                                                    <TextField
                                                        fullWidth
                                                        error={Boolean(touched.itemName && errors.itemName)}
                                                        helperText={touched.itemName && errors.itemName}
                                                        onBlur={handleBlur}
                                                        label="Item Name *"
                                                        name='itemName'
                                                        value={itemData.itemName}
                                                        id='itemName'
                                                        onChange={(e) => handleChange(e)}
                                                        variant="outlined"
                                                        size="small"
                                                        type='text'
                                                    />
                                                </Grid>
                                                <Grid item md={12} xs={12}>
                                                    <TextField
                                                        fullWidth
                                                        error={Boolean(touched.defBarcode && errors.defBarcode)}
                                                        helperText={touched.defBarcode && errors.defBarcode}
                                                        onBlur={handleBlur}
                                                        label="Default Barcode"
                                                        name='defBarcode'
                                                        value={itemData.defBarcode}
                                                        id='defBarcode'
                                                        onChange={(e) => handleChange(e)}
                                                        variant="outlined"
                                                        size="small"
                                                        type='text'
                                                    />
                                                </Grid>
                                                <Grid item md={12} xs={12}>
                                                    <TextField
                                                        select
                                                        fullWidth
                                                        error={Boolean(touched.itemCategoryID && errors.itemCategoryID)}
                                                        helperText={touched.itemCategoryID && errors.itemCategoryID}
                                                        onBlur={handleBlur}
                                                        label="Item Category *"
                                                        name='itemCategoryID'
                                                        value={itemData.itemCategoryID}
                                                        id='itemCategoryID'
                                                        onChange={(e) => handleChange(e)}
                                                        variant="outlined"
                                                        size="small"
                                                    >
                                                        <MenuItem key={0} value={0}>Select Item Category</MenuItem>
                                                        {categoryList.map((row) => (
                                                            <MenuItem key={row.CategoryID} value={row.CategoryID}>{row.CategoryID} - {row.CategoryName}</MenuItem>
                                                        ))}
                                                    </TextField>
                                                </Grid>
                                                <Grid item md={12} xs={12}>
                                                    <TextField
                                                        fullWidth
                                                        error={Boolean(touched.sellingPrice && errors.sellingPrice)}
                                                        helperText={touched.sellingPrice && errors.sellingPrice}
                                                        onBlur={handleBlur}
                                                        label="Selling Price *"
                                                        name="sellingPrice"
                                                        value={itemData.sellingPrice}
                                                        id="sellingPrice"
                                                        onChange={(e) => handleChange(e)}
                                                        onFocus={() => {
                                                            setItemData((prev) => ({
                                                                ...prev,
                                                                sellingPrice: prev.sellingPrice === 0.0 ? "" : prev.sellingPrice,
                                                            }));
                                                        }}
                                                        inputProps={{
                                                            inputMode: "decimal",
                                                            pattern: "^[0-9]*\\.?[0-9]{0,2}$",
                                                        }}
                                                        onKeyDown={(e) => {
                                                            const value = e.target.value;
                                                            const decimalIndex = value.indexOf(".");
                                                            if (!/[0-9]/.test(e.key) && e.key !== "Backspace" && e.key !== "Delete" && e.key !== ".") {
                                                                e.preventDefault();
                                                            }
                                                            if (e.key === "." && decimalIndex !== -1) {
                                                                e.preventDefault();
                                                            }
                                                            if (decimalIndex !== -1 && value.substring(decimalIndex + 1).length >= 2 && e.key !== "Backspace" && e.key !== "Delete") {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        variant="outlined"
                                                        size="small"
                                                        type="text"
                                                    />

                                                </Grid>
                                                <Grid item md={12} xs={12}>
                                                    <TextField
                                                        fullWidth
                                                        error={Boolean(touched.costPrice && errors.costPrice)}
                                                        helperText={touched.costPrice && errors.costPrice}
                                                        onBlur={handleBlur}
                                                        label="Cost Price *"
                                                        name="costPrice"
                                                        value={itemData.costPrice}
                                                        id="costPrice"
                                                        onChange={(e) => handleChange(e)}
                                                        onFocus={() => {
                                                            setItemData((prev) => ({
                                                                ...prev,
                                                                costPrice: prev.costPrice === 0.0 ? "" : prev.costPrice,
                                                            }));
                                                        }}
                                                        inputProps={{
                                                            inputMode: "decimal",
                                                            pattern: "^[0-9]*\\.?[0-9]{0,2}$",
                                                        }}
                                                        onKeyDown={(e) => {
                                                            const value = e.target.value;
                                                            const decimalIndex = value.indexOf(".");
                                                            if (!/[0-9]/.test(e.key) && e.key !== "Backspace" && e.key !== "Delete" && e.key !== ".") {
                                                                e.preventDefault();
                                                            }
                                                            if (e.key === "." && decimalIndex !== -1) {
                                                                e.preventDefault();
                                                            }
                                                            if (decimalIndex !== -1 && value.substring(decimalIndex + 1).length >= 2 && e.key !== "Backspace" && e.key !== "Delete") {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        variant="outlined"
                                                        size="small"
                                                        type="text"
                                                    />
                                                </Grid>
                                                <Grid item md={12} xs={12}>
                                                    <TextField
                                                        fullWidth
                                                        error={Boolean(touched.itemRemark && errors.itemRemark)}
                                                        helperText={touched.itemRemark && errors.itemRemark}
                                                        onBlur={handleBlur}
                                                        label="Item Remark"
                                                        name='itemRemark'
                                                        value={itemData.itemRemark}
                                                        id='itemRemark'
                                                        onChange={(e) => handleChange(e)}
                                                        variant="outlined"
                                                        size="small"
                                                        type='text'
                                                        multiline
                                                        rows={4}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid item md={6} xs={12}>
                                            <Grid container spacing={3}>
                                                <Grid item md={12} xs={12}>
                                                    <input
                                                        ref={inputRef}
                                                        type='file'
                                                        accept='image/*'
                                                        onChange={(e) => uploadImage(e)}
                                                        className='inputImage'
                                                        disabled={previewImg}
                                                        style={{
                                                            width: '100%',
                                                            padding: '8px',
                                                            border: '1px solid #ced4da',
                                                            borderRadius: '4px',
                                                            backgroundColor: '#fff',
                                                            color: '#000000',
                                                            outline: 'none',
                                                            boxShadow: 'none',
                                                            boxSizing: 'border-box',
                                                            height: 'auto'
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid item md={12} xs={12}>
                                                    {false ?
                                                        <>
                                                            {isImageUpload ?
                                                                <>
                                                                    <center>
                                                                        {previewImg ?
                                                                            <img
                                                                                src={previewImg}
                                                                                width='180px'
                                                                                height='180px'
                                                                                alt='item'
                                                                            />
                                                                            :
                                                                            <img
                                                                                src={logo}
                                                                                width='200px'
                                                                                height='180px'
                                                                                alt='item'
                                                                            />
                                                                        }
                                                                    </center>
                                                                    <center>
                                                                        {previewImg ?
                                                                            <IconButton>
                                                                                <CancelIcon
                                                                                    sx={{ color: 'red' }}
                                                                                    onClick={removeImage}
                                                                                />
                                                                            </IconButton>
                                                                            : null}
                                                                    </center>
                                                                </>
                                                                :
                                                                <>
                                                                    <center>
                                                                        {previewImg && false ?
                                                                            <img
                                                                                src={`https://serverrion.mylksystems.store/Assets/Items/${previewImg}`}
                                                                                width='180px'
                                                                                height='180px'
                                                                            />
                                                                            :
                                                                            <img
                                                                                src={logo}
                                                                                width='180px'
                                                                                height='180px'
                                                                            />
                                                                        }
                                                                    </center>
                                                                    <center>
                                                                        {previewImg ?
                                                                            <IconButton>
                                                                                <CancelIcon
                                                                                    sx={{ color: 'red' }}
                                                                                    onClick={removeImage}
                                                                                />
                                                                            </IconButton>
                                                                            : null}
                                                                    </center>
                                                                </>
                                                            }
                                                        </>
                                                        :
                                                        <>
                                                            <center>
                                                                {previewImg && !false ?
                                                                    <img
                                                                        src={previewImg}
                                                                        width='180px'
                                                                        height='180px'
                                                                    />
                                                                    :
                                                                    <img
                                                                        src={logo}
                                                                        width='180px'
                                                                        height='180px'
                                                                    />
                                                                }
                                                            </center>
                                                            <center>
                                                                {previewImg ?
                                                                    <IconButton>
                                                                        <CancelIcon
                                                                            sx={{ color: 'red' }}
                                                                            onClick={removeImage}
                                                                        />
                                                                    </IconButton>
                                                                    : null}
                                                            </center>
                                                        </>
                                                    }

                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid item md={4} xs={12} sx={{ display: 'flex', justifyContent: 'start', alignItems: 'center' }}>
                                            <Typography>Active</Typography>
                                            &nbsp;
                                            <Switch
                                                checked={itemData.status}
                                                onChange={handleStatusChange}
                                                status="isActive"
                                                label="Status"
                                            />

                                        </Grid>
                                        <Grid item md={4} xs={12} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                            <Typography>Chef Prep</Typography>
                                            &nbsp;
                                            <Switch
                                                checked={itemData.isChefPrep}
                                                onChange={handleChefPrepChange}
                                                status="isChefPrep"
                                                label="Chef Prep"
                                            />

                                        </Grid>
                                        <Grid item md={4} xs={12} sx={{ display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
                                            <Typography>Is Favourite</Typography>
                                            &nbsp;
                                            <Switch
                                                checked={itemData.isFavourite}
                                                onChange={handleFavouriteChange}
                                                status="isActive"
                                                label="Status"
                                            />

                                        </Grid>
                                        <Grid item md={12} xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                                            {false ? null
                                                :
                                                <Button
                                                    variant="contained"
                                                    sx={{ width: '30%' }}
                                                    onClick={ClearData}
                                                >
                                                    clear
                                                </Button>
                                            }

                                            &nbsp; &nbsp; &nbsp;
                                            <Button
                                                variant="contained"
                                                type='submit'
                                                sx={{ width: '30%' }}
                                            >
                                                { 'Submit'}
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </form>
                        )}
                    </Formik>
                </Container>
            </DialogContent>
        </Dialog >
    )
}
